<div class="reports-container">
  <div class="reports-topbar">
    <div class="topbar-left">
      <h1>
        Case / Job Usage
        <small>Items issued per case or job this period</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i>
        <a routerLink="/reports">Reports</a> /
        <span class="current">Case / Job Usage</span>
      </div>
    </div>
    <div class="topbar-right">
      <app-report-date-range />
      <a routerLink="/reports" class="btn btn-outline btn-sm">
        <i class="bi bi-arrow-left"></i> Back to Reports
      </a>
      <button class="btn btn-primary" (click)="exportData()">
        <i class="bi bi-download"></i> Export
      </button>
    </div>
  </div>

  <div class="report-period">
    <i class="bi bi-calendar3"></i>
    <span>Showing data for {{ dateRange.appliedLabel() }}</span>
  </div>

  <div class="report-card">
    <div class="report-header">
      <div class="report-title">
        <i class="bi bi-briefcase" style="color:#D31F26;"></i>
        <h2>Case / Job Usage</h2>
        <span class="report-badge">{{ entries().length }} cases</span>
      </div>
    </div>

    <div class="report-body">
      <div class="report-stats case-usage-stats">
        <div class="stat-item">
          <span class="stat-label">Cases / Jobs</span>
          <span class="stat-value">{{ entries().length }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">Items Issued</span>
          <span class="stat-value">{{ totalItems() }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">Total Value</span>
          <span class="stat-value">{{ formatCurrency(totalValue()) }}</span>
        </div>
      </div>

      <div class="funeral-usage-list">
        @for (entry of entries(); track entry.id) {
          <div class="usage-row">
            <div class="usage-main">
              <span class="usage-funeral">{{ entry.caseRef }} · {{ entry.caseName || entry.branch || '—' }}</span>
              <small class="usage-date">
                {{ formatDate(entry.date) }}
                @if (entry.caseType) {
                  <span class="usage-tag">{{ entry.caseType }}</span>
                }
              </small>
            </div>
            <div class="usage-meta">
              <span class="usage-items-count">{{ entry.itemsIssued }} items</span>
              <strong class="usage-value">{{ formatCurrency(entry.totalValue) }}</strong>
            </div>
          </div>
        } @empty {
          <p class="report-empty">No case / job usage records for this period.</p>
        }
      </div>

      <div class="report-footer">
        <span>{{ entries().length }} cases for {{ dateRange.appliedLabel() }}</span>
      </div>
    </div>
  </div>
</div>
